import React, { createContext, useState, useEffect, useMemo } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    // This effect runs once on mount to set the initial theme from localStorage
    // or based on user's system preference.
    const getInitialTheme = () => {
      if (typeof window !== 'undefined' && window.localStorage) {
        const storedPrefs = window.localStorage.getItem('brainybees-theme');
        if (typeof storedPrefs === 'string') {
          return storedPrefs;
        }
      }
      // If no preference is stored, you could default to system preference
      // const userMedia = window.matchMedia('(prefers-color-scheme: dark)');
      // if (userMedia.matches) {
      //   return 'dark';
      // }
      return 'light'; // Default to light theme
    }
    setTheme(getInitialTheme());
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    window.localStorage.setItem('brainybees-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};